module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1222.dd448a4b.png";